import React from 'react';
import Draggable from 'react-draggable'
import properties from '../../../constants/Properties';
import audioEditorUtils from '../utils/AudioEditorUtils';
import { connect } from 'react-redux';
import mouseUtils from '../../utils/MouseUtils';
import { setMarkerPosition, splitAudio } from '../../../actions/AudioEditorActions';
import storeManager from '../../../store/StoreManager';
import appParameters from '../../utils/AppParameters';
import saveManager from '../../utils/SaveManager';
import playController from '../../utils/PlayController';
import hoverManager from '../../utils/HoverManager';
import audioToolUtils from '../../audioTool/utils/AudioToolUtils';
import {setShortcutsTarget} from '../../../actions/CurrentSlideActions';
import locales from '../../../locales/LocalesManager';
import platformDetection from "../../utils/PlatformDetection";

const MarkerContent = React.createClass({
    getInitialState () {
        return {
            isOver: false,
            isSplitOver: false,
            isThumbActive: false,
            isControlPointOver: false
        };
    },
    onMouseIn() {
        this.setState({
            isOver: true
        });
    },
    onMouseOut() {
        this.setState({
            isOver: false
        });
    },
    onControlPointMouseIn() {
        hoverManager.show(this.refs.addControlPoint, 'addControlPoint');

        this.setState({
            isControlPointOver: true
        });
    },
    onControlPointMouseOut() {
        hoverManager.hide();

        this.setState({
            isControlPointOver: false
        });
    },
    onSplitMouseIn() {
        hoverManager.show(this.refs.split, 'splitAudio');

        this.setState({
            isSplitOver: true,
            isOver: false
        });
    },
    onSplitMouseOut() {
        hoverManager.hide();

        this.setState({
            isSplitOver: false,
            isOver: false
        });
    },
    onMouseDown(e) {
        if (playController.isPlaying)
            return;

        var touchPosition = mouseUtils.getTouchPosition(e);

        this.setState({
            startPosition: this.props.markerPosition,
            startClientX: touchPosition.x,
            isThumbActive: true
        });
    },
    onMouseMove(e) {
        if (playController.isPlaying)
            return;

        this.updatePosition(e);
    },
    onMouseUp(e) {
        if (playController.isPlaying)
            return;

        this.setState({
            isThumbActive: false
        });

        this.updatePosition(e);
    },
    updatePosition(e) {
        var touchPosition = mouseUtils.getTouchPosition(e);
        var offsetX = touchPosition.x - this.state.startClientX;
        var newPosition = this.state.startPosition + audioEditorUtils.getItemTimePosition(offsetX);

        if (newPosition < 0)
            newPosition = 0;

        const state = storeManager.getState();
        var timelineWidth = state.audioEditor.timelineWidth;
        timelineWidth = audioEditorUtils.getItemTimePosition(timelineWidth);

        if (newPosition > timelineWidth)
            newPosition = timelineWidth;

        this.props.dispatch(setMarkerPosition(newPosition));
    },
    isSplitVisible() {
        if (playController.isPlaying || audioEditorUtils.isControlPointAction)
            return false;

        var markerPosition = this.props.markerPosition;
        var selectedAudio = audioEditorUtils.getSelectedAudio();

        if (selectedAudio && markerPosition >= 0) {
            var leftPos = selectedAudio.model.left;
            var rightPos = leftPos + selectedAudio.model.duration;
            var minimumSize = 2 * properties.ARROW_SIZE + properties.SPLIT_BUTTON_SIZE;
            var itemWidth = audioEditorUtils.getSlideWidth(selectedAudio.model.duration);

            if (markerPosition > leftPos && markerPosition < rightPos && (markerPosition - leftPos) >= properties.AUDIO_MINIMUM_LENGTH && (rightPos - markerPosition) >= properties.AUDIO_MINIMUM_LENGTH && itemWidth > minimumSize)
                return true;
            else
                return false;
        } else
            return false;
    },
    getSplitTopPosition() {
        var selectedAudio = audioEditorUtils.getSelectedAudio();
        var topPosition;
        var timelineHeight = audioToolUtils.timelineHeight();

        if (selectedAudio) {
            topPosition = selectedAudio.index * timelineHeight + (timelineHeight / 2 - properties.DELETE_BUTTON_SIZE / 2) + properties.RULER_HEIGHT + 1;
        } else {
            topPosition = timelineHeight / 2 - properties.DELETE_BUTTON_SIZE / 2 + properties.RULER_HEIGHT + 1;
        }

        return topPosition
    },
    getAddControlPointPosition() {
        var selectedAudio = audioEditorUtils.getSelectedAudio();
        var topPosition;
        var timelineHeight = audioToolUtils.timelineHeight();

        if (selectedAudio) {
            topPosition = selectedAudio.index * timelineHeight + properties.RULER_HEIGHT + 1;
        } else {
            topPosition = timelineHeight / 2 - properties.DELETE_BUTTON_SIZE / 2 + properties.RULER_HEIGHT + 1;
        }

        return topPosition
    },
    onAddControlPoint(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (audioEditorUtils.addControlPointHandler)
            audioEditorUtils.addControlPointHandler();
    },
    onSplit(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        var markerPosition = this.props.markerPosition;
        var selectedAudio = audioEditorUtils.getSelectedAudio();

        setTimeout(function() {
            this.props.dispatch(splitAudio(selectedAudio.model, markerPosition));
            audioEditorUtils.addActionToHistory();
            saveManager.isContentChanged(true);

            if (!platformDetection.isIOS()) {
                setTimeout(function () {
                    var markerElement = document.getElementById('markerHead');

                    if (markerElement)
                        markerElement.focus();
                }.bind(this), 10);
            }
        }.bind(this), 10);

        saveManager.isContentChanged(true);
    },
    updateMarker() {
        this.forceUpdate();
    },
    onMarkerFocus() {
        if (mouseUtils.isFirstMarkerFocus) {
            mouseUtils.isFirstMarkerFocus = false;
            this.props.dispatch(setShortcutsTarget(true));
        }
    },
    onKeyDownOnMarker(e) {
        var step = 2;
        var offsetX = 0;

        switch (true) {
            case (e.keyCode == 37) : { // LEFT
                offsetX = -step;
                break;
            }
            case (e.keyCode == 39) : { // RIGHT
                offsetX = step;
                break;
            }
        }

        var newPosition = this.props.markerPosition + audioEditorUtils.getItemTimePosition(offsetX);

        if (newPosition < 0)
            newPosition = 0;

        const state = storeManager.getState();
        var timelineWidth = state.audioEditor.timelineWidth;
        timelineWidth = audioEditorUtils.getItemTimePosition(timelineWidth);

        if (newPosition > timelineWidth)
            newPosition = timelineWidth;

        this.props.dispatch(setMarkerPosition(newPosition));

        setTimeout(function () {
            var newPos = audioEditorUtils.getMarkerPosition();
            playController.checkScrollPosition(newPos, true);
        }.bind(this), 100);
    },
    render() {
        if (this.props.markerPosition == -1)
            return (<div/>);

        audioEditorUtils.markerUpdater = this.updateMarker;

        var timelinesLength = audioEditorUtils.getTimelinesLength();
        var maxTimelines = audioEditorUtils.getMaxTimelinesRelatedToHeight();

        if (maxTimelines < timelinesLength)
            timelinesLength = maxTimelines;

        const rulerHeight = properties.RULER_HEIGHT;
        const timelineHeight = timelinesLength * audioToolUtils.timelineHeight();
        const width = 2;
        var leftPos = audioEditorUtils.getItemPosition(this.props.markerPosition);
        var lineOffset = 5;
        var lineHeight = timelineHeight + lineOffset;
        var color = '#272727';

        if (this.state.isOver || this.state.isThumbActive)
            color = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;

        var menuStyle = {
            position: 'absolute',
            cursor: 'default',
            userSelect: 'none',
            WebkitUserSelect: 'none',
            top: - rulerHeight,
            left: leftPos
        };

        var lineStyle = {
            position: 'absolute',
            top: rulerHeight - lineOffset,
            left: - width / 2,
            width: width,
            height: lineHeight
        };

        const headButtonStyle = {
            position: 'absolute',
            top: -3,
            left: -9.15,
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            borderStyle: 'none',
            background: 'none',
            width: 18.3,
            height: 32
        };

        const headStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'block'
        };

        const iconStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            color: color
        };

        const circleStyle = {
            position: 'absolute',
            top: 5,
            left: 0,
            width: 14,
            height: 14,
            borderRadius: 50,
            background: color,
            display: 'block'
        };

        var lineSize = 10;
        var lineBreak = 5;
        var length = Math.ceil(lineHeight / (lineSize + lineBreak));
        var i;
        var elements = [];

        for (i=0; i<length; i++) {
            var elementStyle = {
                position: 'absolute',
                width: width,
                height: lineSize,
                top: i * (lineSize + lineBreak),
                left: 0,
                background: color
            };

            elements.push(<div style={elementStyle} key={'marker_' + i}/>);
        }

        // Split button
        var displayValue = 'none';

        if (this.isSplitVisible())
            displayValue = 'block';

        var splitHeight = properties.SPLIT_BUTTON_SIZE;
        var spliHolderButtonStyle = {
            position: 'absolute',
            top: this.getSplitTopPosition(),
            left: - splitHeight / 2,
            display: displayValue,
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            borderStyle: 'none',
            background: 'none',
            width: 32,
            height: 32
        };

        var spliHolderStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            display: 'block'
        };

        var splitSrc = appParameters.RESOURCES_LOCATION() + 'assets/scissor_normal.svg';

        if (this.state.isSplitOver)
            splitSrc = appParameters.RESOURCES_LOCATION() + 'assets/scissor_hover.svg';

        const spliIconStyle = {
            position: 'absolute',
            top: 0,
            left: 0,
            width: splitHeight,
            height: splitHeight
        };

        // Add control point
        if (this.state.isControlPointOver)
            color = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;

        var btnSize = audioToolUtils.getGraphControlPointSize();
        var borderWidth = 2;
        var addControlPointStyle = {
            position: 'absolute',
            top: this.getAddControlPointPosition(),
            left: - btnSize / 2 - borderWidth,
            display: displayValue,
            margin: 0,
            padding: 0,
            fontSize: 'initial',
            boxSizing: 'initial',
            background: 'white',
            borderStyle: 'solid',
            borderWidth: borderWidth,
            borderColor: '#48b221',
            borderRadius: 100,
            width: btnSize,
            height: btnSize,
            fontSize: 12
        };

        const addControlPointIconStyle = {
            position: 'absolute',
            top: borderWidth,
            left: borderWidth,
            color: color
        };

        return (
            <Draggable axis="none" position={{x:0, y:0}} onStart={this.onMouseDown} onDrag={this.onMouseMove} onStop={this.onMouseUp}>
                <div style={menuStyle}>
                    <div style={lineStyle}>
                        {elements}
                    </div>

                    <button id='markerHead' aria-label={locales.getCaption('markerLabel', 'other')} style={headButtonStyle} ref='audioMarker' onFocus={this.onMarkerFocus} onKeyDown={this.onKeyDownOnMarker} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                        <span style={headStyle} >
                            <span style={circleStyle}/>
                            <i style={iconStyle} className={'fa fa-map-marker fa-2x'}></i>
                        </span>
                    </button>

                    <button id='addVolumeControlPoint' aria-label={locales.getCaption('addControlPointLabel', 'other')} style={addControlPointStyle} ref='addControlPoint' onTouchStart={this.onAddControlPoint} onClick={this.onAddControlPoint} onMouseOver={this.onControlPointMouseIn} onMouseOut={this.onControlPointMouseOut}>
                        <i style={addControlPointIconStyle} className={'fa fa-plus'}></i>
                    </button>

                    <button aria-label={locales.getCaption('splitLabel', 'other')} style={spliHolderButtonStyle} onMouseOver={this.onSplitMouseIn} onMouseOut={this.onSplitMouseOut} onTouchStart={this.onSplit} onClick={this.onSplit}>
                        <span style={spliHolderStyle}>
                            <img alt='' aria-hidden='true' ref='split' style={spliIconStyle} src={splitSrc}/>
                        </span>
                    </button>
                </div>
            </Draggable>
        );
    }
});

function mapStateToProps(state) {
    var markerPosition = state.audioEditor.markerPosition;
    var timelines = state.audioEditor.timelines;

    if (markerPosition == undefined)
        markerPosition = -1;

    return {
        markerPosition,
        timelines
    };
}

export const Marker = connect(mapStateToProps)(MarkerContent);



/** WEBPACK FOOTER **
 ** ./src/components/audioEditor/menus/Marker.js
 **/